var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TNC10000'),_c('div',[_vm._v(_vm._s(_vm.sTitulo))]),_c('BNC10000')],1)}
var staticRenderFns = []

export { render, staticRenderFns }